import './Tag.scss';

interface TagProps {
    label: string;
    variant?: 'default' | 'primary' | 'secondary';
    size?: 'xs' | 'sm' | 'md' | 'lg';
    index?: number;
}

function Tag({ label, variant = 'default', size = 'md' }: TagProps) {
    return <span className={`tag tag--${variant} tag--${size}`}>{label}</span>;
}

export default Tag;
